// @ts-check
import * as serializationUtils from '../../serializationUtils';
var collectionsSchema = {
  dashboard: {
    page: {
      parentCollection: 'pages',
      '*': {
        parentCollection: 'widgets',
        caption: {}
      },
      pieChart: {
        parentCollection: 'widgets',
        serie: 'series',
        caption: {}
      },
      lineChart: {
        parentCollection: 'widgets',
        serie: 'series',
        caption: {}
      },
      barChart: {
        parentCollection: 'widgets',
        serie: 'series',
        caption: {}
      },
      columnChart: {
        parentCollection: 'widgets',
        serie: 'series',
        caption: {}
      },
      table: {
        parentCollection: 'widgets',
        column: 'columns',
        caption: {}
      }
    },
    cube: {
      parentCollection: 'cubes',
      axis: 'axes',
      measure: {
        parentCollection: 'measures',
        filter: 'filters'
      }
    },
    dashboardLayout: {
      pageLayout: 'pageLayouts'
    }
  }
};
export var fromXml = function fromXml(xml) {
  return serializationUtils.fromXml(xml, collectionsSchema);
};
export var toXml = function toXml(state) {
  return serializationUtils.toXml(state, function (name) {
    return 'bi:' + name;
  }, collectionsSchema);
};
export function toXmlBase64(state) {
  // http://ecmanaut.blogspot.com/2006/07/encoding-decoding-utf8-in-javascript.html
  return btoa(unescape(encodeURIComponent(toXml(state))));
}